import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=45287f82&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45287f82')) {
      api.createRecord('45287f82', component.options)
    } else {
      api.reload('45287f82', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=45287f82&", function () {
      api.rerender('45287f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n1n1Tw2dFAm3/JS/comp/IncreaseNumber.vue"
export default component.exports